import type { SimpleChanges } from '@angular/core';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  output,
  inject,
  input,
} from '@angular/core';

import {
  ButtonComponent,
  ButtonDropdownIndicatorDirective,
  ConnectedOverlayDirective,
  DropdownComponent,
  DropdownItemComponent,
  OverlayOriginDirective,
  RtStatefulComponent,
} from '@core/user-interface-legacy';

import { DynamicHelpers } from '../../../helpers';
import type { DynamicText, SelectOptionsT, SelectOptionT } from '../../../types';

type State = {
  dropdownOpen: boolean;
  activeOptions: SelectOptionsT;
};

@Component({
  selector: 'rti-dynamic-form-additional-groups-dropdown',
  templateUrl: './dynamic-form-additional-groups-dropdown.component.html',
  styleUrls: ['./dynamic-form-additional-groups-dropdown.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ButtonComponent,
    ButtonDropdownIndicatorDirective,
    ConnectedOverlayDirective,
    DropdownComponent,
    DropdownItemComponent,
    OverlayOriginDirective,
  ],
})
export class DynamicFormAdditionalGroupsComponent extends RtStatefulComponent<State> {
  private readonly helpers = inject(DynamicHelpers);

  public readonly label = input<DynamicText>(undefined!);
  public readonly options = input<SelectOptionsT>(undefined!);
  public readonly selected = input<string[]>(undefined!);

  public select = output<string>();

  constructor() {
    const cdRef = inject(ChangeDetectorRef);

    super(cdRef);
    this.createState({ dropdownOpen: false, activeOptions: [] });
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if ('options' in changes || 'selected' in changes) {
      this.setState({
        ...this.state,
        activeOptions: this.options().filter(o => !this.selected().includes(o.value)),
      });
    }
  }

  public buildText(text: DynamicText): string {
    return this.helpers.buildText(text);
  }

  public get disabled(): boolean {
    return this.state.activeOptions.length === 0;
  }

  public toggleDropdown(): void {
    this.setState({ ...this.state, dropdownOpen: !this.state.dropdownOpen });
  }

  public selectOption(option: SelectOptionT): void {
    this.setState({ ...this.state, dropdownOpen: false });
    this.select.emit(option.value);
  }

  public trackByOption(_index: number, option: SelectOptionT): string {
    return option.value;
  }
}
